PageVue
  .fp-vertical-spacing
    .fp-vertical-spacing--line
      .fp-horizontal-spacing.-items-center
        .fp-horizontal-spacing--column.-expand
          .fp-horizontal-spacing.-s-sm.-items-center
            .fp-horizontal-spacing--column
              i.fp-icon.fp-glyph-calendar-check.-s18
            .fp-horizontal-spacing--column
              h2.fp-title.-color-shade-700 {{ t('postsPage.title') }}
        .fp-horizontal-spacing--column
          router-link.fp-link.-no-text-decoration(:to='{ name: \'createPost\', params: { clubSlug }}' data-test='create-post')
            FairplayerButtonVue(icon='plus' :text='t(\'postsPage.createPost\')')
    .fp-vertical-spacing--line
      PostsTableVue
